import Reveal from '@/components/feature/Reveal';
import { discussions } from '@/mocks/home';

export default function DiscussionFeed() {
  return (
    <section id="discussion" className="scroll-mt-28 bg-background-50">
      <div className="mx-auto max-w-7xl px-4 py-14 md:px-6 md:py-20">
        <Reveal>
          <header className="flex flex-col gap-3 md:flex-row md:items-end md:justify-between">
            <div className="max-w-2xl">
              <p className="text-xs font-medium uppercase tracking-[0.3em] text-primary-600">
                COMMUNITY FEED
              </p>
              <h2 className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-4xl">
                大家都在聊什么
              </h2>
              <p className="mt-3 text-sm leading-relaxed text-foreground-600 md:text-base">
                标题加短摘要，扫一眼就知道值不值得点开。讨论越多的帖子，排序越靠前。
              </p>
            </div>
            <a
              href="#trending"
              className="inline-flex cursor-pointer items-center gap-1.5 whitespace-nowrap text-sm font-medium text-primary-700 hover:text-primary-600"
            >
              查看完整榜单
              <i className="ri-arrow-right-line text-base" />
            </a>
          </header>
        </Reveal>

        <div className="mt-8 border-t border-background-200/70">
          {discussions.map((item, index) => (
            <Reveal key={item.title} delay={index * 60}>
              <article className="flex cursor-pointer items-start gap-5 border-b border-background-200/70 py-5 transition-colors hover:bg-background-100/60">
                <div className="hidden w-24 shrink-0 sm:block">
                  <span className="inline-flex rounded-full bg-secondary-100 px-2.5 py-0.5 text-[11px] font-medium text-secondary-900">
                    {item.tag}
                  </span>
                </div>

                <div className="min-w-0 flex-1">
                  <h3 className="font-heading text-base font-bold text-foreground-950 transition-colors hover:text-primary-700 md:text-lg">
                    {item.title}
                  </h3>
                  <p className="mt-2 line-clamp-2 text-sm leading-relaxed text-foreground-600">
                    {item.summary}
                  </p>
                  <div className="mt-3 flex flex-wrap items-center gap-4 text-xs text-foreground-500">
                    <span className="inline-flex items-center gap-1.5 sm:hidden">
                      <i className="ri-price-tag-3-line text-sm" />
                      {item.tag}
                    </span>
                    <span className="inline-flex items-center gap-1.5">
                      <i className="ri-chat-3-line text-sm" />
                      {item.comments} 条讨论
                    </span>
                    <span className="inline-flex items-center gap-1.5">
                      <i className="ri-time-line text-sm" />
                      {item.time}
                    </span>
                  </div>
                </div>

                {item.image ? (
                  <div className="hidden h-20 w-28 shrink-0 overflow-hidden rounded-md md:block">
                    <img
                      src={item.image}
                      alt={`${item.title} 配图`}
                      title={`${item.tag} 讨论配图`}
                      className="h-full w-full object-cover object-top"
                    />
                  </div>
                ) : null}
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}